import type React from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

/**
 * The App component is used to render content which should be present on _all_ routes within this app
 */
export function App(props: {children?: React.ReactNode}) {
  return <ErrorBoundary>{props.children}</ErrorBoundary>
}

try{ App.displayName ||= 'App' } catch {}